exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title[data-v-dc7f8900] {\n  font-weight: bold;\n}\n.section-box[data-v-dc7f8900] {\n  padding-left: 1em;\n  text-indent: -1em;\n}\n.indent[data-v-dc7f8900] {\n  padding-left: 1em;\n}\n", ""]);
